export default function () {
    const tabsContainer = document.querySelector('tabs-container');

    if (!tabsContainer) return;

    const tabsNav = document.createElement('tabs-nav');
    const tabContents = tabsContainer.querySelectorAll('tab-content');

    tabContents.forEach(tabContent => {
        const tabLink = document.createElement('tab-link');
        tabLink.textContent = tabContent.getAttribute('data-name');
        tabsNav.appendChild(tabLink);
        tabContent.classList.add('unactive');
    });

    tabsContainer.insertAdjacentElement('afterbegin', tabsNav);

    const activeSet = tabsContainer.getAttribute('data-active-tab');

    if (activeSet) {
        tabsNav.querySelectorAll('tab-link')[+activeSet].classList.add('active');
        tabContents.forEach(tabContent => tabContent.classList.add('unactive'));
        tabContents[+activeSet].classList.add('active');
    } else {
        tabsNav.querySelector('tab-link').classList.add('active');
        tabContents[0].classList.remove('unactive');
        tabContents[0].classList.add('active');
    }

    const tabLinkClick = (index) => {
        tabContents.forEach(tab => tab.classList.remove('active'));
        tabContents.forEach(tab => tab.classList.add('unactive'));
        tabContents[index].classList.add('active');

        const tabsLinks = tabsNav.querySelectorAll('tab-link');
        tabsLinks.forEach(tabLink => tabLink.classList.remove('active'));
        tabsLinks[index].classList.add('active');
    }

    tabsNav.querySelectorAll('tab-link').forEach((tabLink, index) => {
        tabLink.addEventListener('click', () => tabLinkClick(index));
    });

    const tabsHidden = tabsContainer.getAttribute('data-hidden-tabs');

    if (tabsHidden) {
        let tabsToHideIndexes = tabsHidden.trim().replace(' ', '').split(',');

        if (activeSet) {
            tabsToHideIndexes = tabsToHideIndexes.filter(tabIndex => +tabIndex !== +activeSet);
        }

        tabsToHideIndexes.forEach(tabIndex => {
            tabsNav.querySelectorAll('tab-link')[+tabIndex].style.display = 'none';
        });
    }

    tabsContainer.classList.add('tabs-built');
}